import React, { useState, useEffect } from 'react'
import {
	HeaderWrapper,
	HeaderContainer,
	Logo,
	NavMenu,
	NavItem,
	NavLink,
	SubMenu,
	SubMenuItem,
	MobileMenuButton,
	RequestButton,
	ContactButton,
	ButtonsWrapper,
	NavItemContent,
	DropdownIcon,
} from './branding-header.style'

export const BrandingHeader = () => {
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
	const [activeSubmenu, setActiveSubmenu] = useState(null)
	const [mobileSubmenuOpen, setMobileSubmenuOpen] = useState(null)

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth > 1024 && isMobileMenuOpen) {
				setIsMobileMenuOpen(false)
				setMobileSubmenuOpen(null)
				document.body.style.overflow = 'unset'
			}
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [isMobileMenuOpen])

	const menuItems = [
		{
			title: 'About Us',
			link: '#',
			subItems: [
				{ title: 'Our Story', link: 'https://www.planet-healthcare.com/about-us' },
				{ title: 'Leadership', link: 'https://www.planet-healthcare.com/about-us/leadership' },
				{ title: 'Locations', link: 'https://www.planet-healthcare.com/about-us/locations' },
				{ title: 'Diversity, Equity, and Inclusion', link: 'https://www.planet-healthcare.com/about-us/diversity-equity-and-inclusion' },
				{ title: 'Careers At Planet', link: 'https://www.planet-healthcare.com/about-us/work-for-us' },
			],
		},
		{
			title: 'Client Hub',
			link: '#',
			subItems: [
				{ title: 'Client Overview', link: 'https://www.planet-healthcare.com/clients' },
				{ title: 'Why Planet Healthcare', link: 'https://www.planet-healthcare.com/clients/why-planet-healthcare' },
				{ title: 'Solutions', link: 'https://www.planet-healthcare.com/clients/solutions' },
				{ title: 'Practice Areas', link: 'https://www.planet-healthcare.com/clients/practice-areas' },
				{ title: 'Custom EMR Solutions', link: 'https://www.planet-healthcare.com/clients/custom-emr-solutions' },
				{ title: 'Case Studies', link: 'https://www.planet-healthcare.com/clients/case-studies' },
			],
		},
		{
			title: 'Career Experience',
			link: '#',
			subItems: [
				{ title: 'What You Can Expect', link: 'https://www.planet-healthcare.com/career-experience' },
				{ title: 'Career Services', link: 'https://www.planet-healthcare.com/career-experience/services' },
				{ title: 'Working With Us', link: 'https://www.planet-healthcare.com/career-experience/support' },
				{ title: 'Fraud Alert', link: 'https://www.planet-healthcare.com/privacy-documents/fraud-alert' },
			],
		},
		{
			title: 'Job Openings',
			link: 'https://careers.planet-healthcare.com/',
		},
		{
			title: 'Blog',
			link: 'https://www.planet-healthcare.com/blog',
		},
	]

	const toggleMobileMenu = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen)
		document.body.style.overflow = !isMobileMenuOpen ? 'hidden' : 'unset'
	}

	return (
		<>
			<HeaderWrapper>
				<HeaderContainer>
					<Logo href="/">
						<img style={{ width: '175px', height: 'auto' }} src="/assets/planet/logo.png" alt="Planet Healthcare - A GHR Healthcare Company" />
					</Logo>

					<NavMenu className={isMobileMenuOpen ? 'open' : ''}>
						{menuItems.map((item, index) => (
							<NavItem key={index}>
								<NavItemContent onClick={() => item.subItems && setMobileSubmenuOpen(mobileSubmenuOpen === index ? null : index)}>
									<NavLink href={item.link}>{item.title}</NavLink>
									{item.subItems && <DropdownIcon isOpen={mobileSubmenuOpen === index} />}
								</NavItemContent>
								{item.subItems && (
									<SubMenu isVisible={mobileSubmenuOpen === index}>
										{item.subItems.map((subItem, subIndex) => (
											<SubMenuItem key={subIndex}>
												<NavLink href={subItem.link}>{subItem.title}</NavLink>
											</SubMenuItem>
										))}
									</SubMenu>
								)}
							</NavItem>
						))}
					</NavMenu>

					<ButtonsWrapper>
						<RequestButton href="https://www.planet-healthcare.com/request-services">Request Services</RequestButton>
						<ContactButton href="https://www.planet-healthcare.com/contact-us">Contact Us</ContactButton>
					</ButtonsWrapper>

					<MobileMenuButton onClick={toggleMobileMenu} isOpen={isMobileMenuOpen}>
						<span></span>
						<span></span>
						<span></span>
					</MobileMenuButton>
				</HeaderContainer>
			</HeaderWrapper>
		</>
	)
}
